import { AccessUser } from '../../../generated/globalTypes';

export const permissions = [
  { label: t(['Dapat Memesan', 'Can Order']), value: AccessUser.CAN_ORDER },
  { label: t(['Menambah Staf', 'Add Staff']), value: AccessUser.ADD_STAFF },
];
